import { createAsyncThunk } from '@reduxjs/toolkit';
import { CountryCode } from '@/Enums';
import { ApplicationAccessCountryZonesApi } from '@/Api/ApplicationAccessCountryZones/ApplicationAccessCountryZonesApi';
import { CreateApplicationAccessCountryZoneResponse } from '@/Api/ApplicationAccessCountryZones/CreateApplicationAccessCountryZoneResponse';
import { CreateApplicationAccessCountryZoneRequest } from '@/Api/ApplicationAccessCountryZones/CreateApplicationAccessCountryZoneRequest';
import { UpdateApplicationAccessCountryZoneResponse } from '@/Api/ApplicationAccessCountryZones/UpdateApplicationAccessCountryZoneResponse';
import { UpdateApplicationAccessCountryZoneRequest } from '@/Api/ApplicationAccessCountryZones/UpdateApplicationAccessCountryZoneRequest';
import { CheckApplicationAccessConnectionResponse } from '@/Api/ApplicationAccessCountryZones/CheckApplicationAccessConnectionResponse';
import { CheckApplicationAccessConnectionRequest } from '@/Api/ApplicationAccessCountryZones/CheckApplicationAccessConnectionRequest';
import { GetAllApplicationAccessCountryZoneByCountryResponse } from '@/Api/ApplicationAccessCountryZones/GetAllApplicationAccessCountryZoneByCountryResponse';

const getCountryZonesRequest = createAsyncThunk<GetAllApplicationAccessCountryZoneByCountryResponse, CountryCode>(
  'generatorCountryZones/get-generator-country-zones',
  async (request) => {
    return await ApplicationAccessCountryZonesApi.getCountryZonesGroupedByCountry(request);
  },
);

const createCountryZoneRequest = createAsyncThunk<
  CreateApplicationAccessCountryZoneResponse,
  CreateApplicationAccessCountryZoneRequest
>('applicationAccessCountryZones/create-generator-country-zone', async (request) => {
  return await ApplicationAccessCountryZonesApi.createApplicationAccessCountryZone(request);
});

const updateCountryZoneRequest = createAsyncThunk<
  UpdateApplicationAccessCountryZoneResponse,
  UpdateApplicationAccessCountryZoneRequest
>('applicationAccessCountryZones/update-generator-country-zone', async (request) => {
  return await ApplicationAccessCountryZonesApi.updateApplicationAccessCountryZone(request);
});

const deleteCountryZoneRequest = createAsyncThunk<number, number>(
  'applicationAccessCountryZones/delete-generator-country-zone',
  async (id) => {
    return ApplicationAccessCountryZonesApi.deleteApplicationAccessCountryZone(id);
  },
);

const checkConnectionRequest = createAsyncThunk<
  CheckApplicationAccessConnectionResponse,
  CheckApplicationAccessConnectionRequest
>('applicationAccessCountryZones/check-connection', async (request) => {
  return await ApplicationAccessCountryZonesApi.checkApplicationAccessConnection(request);
});

export const asyncActions = {
  getCountryZonesRequest,
  createCountryZoneRequest,
  updateCountryZoneRequest,
  deleteCountryZoneRequest,
  checkConnectionRequest,
};
